import { UsersComponent } from '../../components/users/UsersComponent';
import { useAppDispatch } from '../../store/hooks/hooks';
import { setDohvaceniUsers } from '../../store/slice/UsersSlice';
import { usersToUsersTable } from '../../common/utils/HelperFunction';
import { Users } from '../../common/types/types';
import UsersService from '../../service/UsersService';

export const UsersContainer = () => {
  const dispatch = useAppDispatch();

  UsersService.getUsers().then((response) => {
    dispatch(setDohvaceniUsers(usersToUsersTable(response.data as Array<Users>)));
  });

  return <UsersComponent />;
};
